import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '@auth';

@Injectable()
export class NoAuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith(this.tokenService.tokenEndpoint)) {
      const authReq = req.clone({
        headers: req.headers.delete('Authorization'),
      });
      return next.handle(authReq);
    }
    return next.handle(req);
  }

  constructor(private tokenService: TokenService) {}
}
